import { forEach, includes, values } from 'lodash';
import {
  DEFAULT_THEME,
  GENIUS_POS_NAME,
  THEMES,
  XENIAL_POS_NAME,
} from '@config/global-constants';
import { XVII18nService } from '@app/i18n/services';

let currentTheme: string = '';

export const getTheme = (): THEMES => {
  return includes(values(THEMES), currentTheme)
    ? (currentTheme as THEMES)
    : DEFAULT_THEME;
};

export const setTheme = (apiTheme: string): void => {
  const root = document.documentElement;
  currentTheme = apiTheme;

  forEach(values(THEMES), (theme: THEMES) => {
    root.classList.remove(`theme-${theme}`);
  });

  root.classList.add(`theme-${getTheme()}`);
};

export const getPOSName = (options: { i18nService: XVII18nService }) => {
  const theme =
    getTheme() === THEMES.XENIAL ? XENIAL_POS_NAME : GENIUS_POS_NAME;

  return options.i18nService.instant(theme);
};
